import { Paper } from "@mui/material";
import { BillStatus, BookStatus, isEmpty, isNumberEmpty } from "../../constants/Constants";

const RoomTodayView = ({ data, handleBookRoom }) => {


    const getRommDetsName = (level, data) => {
        if (level === 1)
            return data.catgName + "(" + data.roomNo + ")";
        else if (level === 2 && !isEmpty(data.bookingId) && (data?.banquetBooking ?? false))
            return data.bookingId;
        else if (level === 2 && !isEmpty(data.bookingId) && !(data?.banquetBooking ?? false))
            return "Booking Id#" + data.bookingId;
        else if (level === 3 && !isEmpty(data.custName))
            return "C: " + data.custName;
        else if (level === 4 && !isEmpty(data.lapsedTime))
            return data.lapsedTime;
        else if (level === 5 && !isEmpty(data.salePersonDetails))
            return "@" + data.salePersonDetails;
        else if (level === 6 && !isEmpty(data.roomType))
            return data.roomType;
        else if (level === 7 && !isEmpty(data.id) && (data.banquetBooking ?? false))
            return "Via Banquet";
        return "";
    };

    const roomBoxColour = (data) => {
        if (!isNumberEmpty(data.billStatus)) {
            if (data.billStatus === BillStatus.MODE_ESTIMATION)
                return "#d8ad8eff";
            else if (data.billStatus === BillStatus.ROOMALLOTEDPARTIALPAID)
                return "#c9aac6";
            else if (data.billStatus === BillStatus.ROOMALLOTEDPAID)
                return "orange";
            else if (data.billStatus === BillStatus.ROOMALLOTEDNOTPAID)
                return "#e26565";
            else if (data.billStatus === BillStatus.ROOMALLOTEDPAIDBUTRESTAURANTNOTPAID)
                return "#e28265";
        }
        if ((data?.roomBookedStatus ?? BookStatus.Single_Booking) === BookStatus.Multiple_Booking) {
            return "#d8ad8eff";
        }
        return "white";
    };


    return (
        <Paper
            key={data.id}
            elevation={0}
            autoHeight
            onClick={() => handleBookRoom(data)}
            className="room-data-container"
            sx={{
                borderRadius: 4,
                backgroundColor: roomBoxColour(data),
            }}>
            <div style={{
                whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                justifyContent: 'center', alignItems: 'center'
            }}>
                <p style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                    fontSize: '14px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                    padding: '2px'
                }}>{getRommDetsName(2, data)}</p>
                <p style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                    fontSize: '12px', justifyContent: 'center', alignItems: 'center', alignContent: 'center'
                    , padding: '2px'
                }}>{getRommDetsName(4, data)}</p>
                <center>
                    <p style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                        fontSize: '15px', justifyContent: 'center', alignItems: 'center'
                        , padding: '2px'
                    }}><b>{getRommDetsName(1, data)}</b></p>
                    <p style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                        fontSize: '15px', justifyContent: 'center', alignItems: 'center'
                        , padding: '2px'
                    }}><b>{getRommDetsName(6, data)}</b></p>
                </center>
                <p style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                    fontSize: '13px', justifyContent: 'center', alignItems: 'center', alignContent: 'center'
                    , padding: '2px'
                }}>{getRommDetsName(3, data)}</p>
                <p style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                    fontSize: '11px', justifyContent: 'center', alignItems: 'center', alignContent: 'center'
                    , padding: '2px'
                }}>{getRommDetsName(5, data)}</p>
                <p style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                    fontSize: '11px', justifyContent: 'center', alignItems: 'center', alignContent: 'center'
                    , padding: '2px'
                }}>{getRommDetsName(7, data)}</p>
            </div>
        </Paper>
    )
}
export { RoomTodayView };